import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const NavigationLoader = () => {
	const location = useLocation();
	const [loading, setLoading] = useState(false);
	const [progress, setProgress] = useState(0);

	useEffect(() => {
		setLoading(true);
		setProgress(0);

		// Animate the progress bar
		const progressTimer = setInterval(() => {
			setProgress((prev) => {
				if (prev >= 90) {
					clearInterval(progressTimer);
					return 90;
				}
				return prev + Math.random() * 35;
			});
		}, 30);

		// Complete the loading
		const completeTimer = setTimeout(() => {
			setProgress(100);
			setTimeout(() => {
				setLoading(false);
				setProgress(0);
			}, 150);
		}, 200);

		return () => {
			clearInterval(progressTimer);
			clearTimeout(completeTimer);
		};
	}, [location.pathname]);

	if (!loading) return null;

	return (
		<div className='fixed top-0 left-0 right-0 z-[60] h-1'>
			<div
				className='h-full bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 transition-all duration-200 ease-out shadow-lg shadow-blue-500/25'
				style={{
					width: `${progress}%`,
					transition:
						progress === 100 ? 'width 200ms ease-out' : 'width 100ms ease-out',
				}}
			/>
		</div>
	);
};
